module.exports = require('./helpers/bundle-url').getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/40192-40447.pbf";